<div class="content">
  <div class="close">
    <button (click)="close()">
      <img
        alt="close"
        width="24"
        height="24"
        src="../../../assets/images/close.svg"
      />
    </button>
  </div>
  <div class="title">环球巴士</div>
  <div class="divider"></div>
  <div class="coupon">首单<span>9折</span>优惠码</div>
  <div class="code"><span *ngIf="code">优惠码：1009</span></div>
  <div class="button">
    <span (click)="getCode()" *ngIf="!code">立即领取</span>
    <span (click)="copy()" *ngIf="code">立即复制</span>
  </div>
  <div class="tip">注：代充类目除外</div>
</div>
